import { GQL_ADD_COLLECTION } from "@/graphql/bundle.graphql";
import useTranslation from "@/hooks/useTranslation";
import { ICollection } from "@/interfaces/bundle.interface";
import { useMutation } from "@apollo/react-hooks";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import TextField from "@material-ui/core/TextField";
import { message } from "antd";
import React, { useState } from "react";

interface IProps {
  open: boolean;
  handleClose: () => void;
  refresh: () => void;
}

interface IFormProps {
  name: string;
  description: string;
  public: boolean;
}

const CreateCollectionDialog: React.FC<IProps> = ({
  open,
  handleClose,
  refresh,
}) => {
  const [addCollection, { data, loading }] = useMutation<
    { addCollection: ICollection },
    { ado: { name: string; description: string; public: boolean } }
  >(GQL_ADD_COLLECTION);

  const [formProps, _setFormProps] = useState<IFormProps>({
    name: "",
    description: "",
    public: true,
  });

  const setFormProps = (values: Partial<IFormProps>) =>
    _setFormProps({ ...formProps, ...values });

  const handleSubmit = async () => {
    await addCollection({ variables: { ado: formProps } });
    message.success(t("collection.create.message"));
    setFormProps({
      name: "",
      description: "",
      public: true,
    });
    refresh();
    handleClose();
  };

  const { t } = useTranslation("bundle");

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t("collection.create.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("collection.create.des")
            .split("\n")
            .map((e) => (
              <p key={e}>{e}</p>
            ))}
        </DialogContentText>
        <TextField
          multiline
          error={formProps.name.length > 32}
          helperText={formProps.name.length > 32 && t("collection.create.val")}
          autoFocus
          margin="dense"
          id="name"
          label={t("collection.create.name")}
          type="text"
          fullWidth
          required
          value={formProps.name}
          onChange={(e) => setFormProps({ name: e.target.value })}
        />
        <TextField
          multiline
          error={formProps.description.length > 3000}
          helperText={
            formProps.description.length > 3000 && t("collection.create.val")
          }
          margin="dense"
          id="description"
          label={t("collection.create.name-des")}
          type="text"
          fullWidth
          required
          value={formProps.description}
          onChange={(e) => setFormProps({ description: e.target.value })}
        />
        <FormControl component="fieldset" required>
          <RadioGroup
            name="privacy"
            value={formProps.public.toString()}
            onChange={(e) => {
              setFormProps({
                public: e.target.value === "true" ? true : false,
              });
            }}
            row
          >
            <FormControlLabel
              value="true"
              control={<Radio color="primary" />}
              label={t("collection.create.public.public")}
            />
            <FormControlLabel
              value="false"
              control={<Radio color="primary" />}
              label={t("collection.create.public.private")}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading} color="default">
          {t("common:cancel")}
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={loading}>
          {t("common:submit")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateCollectionDialog;
